import React from "react";
import ConfigSection from "../../ConfigSection";

const CompanySizeSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Company Size'
      configType='CompanySize'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default CompanySizeSection;
